<template>
  <component
    :is="component"
    ref="confirmationDialog"
    :message="confirmation.confirmMessage ?? ''"
    :data="confirmation.data"
    :description="confirmation.description ?? ''"
  >
    <template #header>
      <span>
        {{ $t('Dialogs.ConfirmationDialog.title') }}
      </span>
    </template>

    <template #dialog-actions="{triggerResolve, triggerReject}">
      <template v-if="confirmation.replies">
        <WorkButton
          v-for="(replyButton, index) in confirmation.replies"
          :key="index"
          @click="triggerResolve(replyButton)"
        >
          {{ replyButton }}
        </WorkButton>
        <WorkButton
          outlined
          @click="triggerReject()"
        >
          {{ $t('Common.cancel') }}
        </WorkButton>
      </template>
      <template v-else>
        <WorkButton
          outlined
          @click="triggerReject()"
        >
          {{ $t('Dialogs.ConfirmationDialog.abort') }}
        </WorkButton>
        <WorkButton @click="triggerResolve()">
          {{ $t('Dialogs.ConfirmationDialog.accept') }}
        </WorkButton>
      </template>
    </template>
  </component>
</template>

<script>
import WorkButton from "@/components/global_components/buttons/WorkButton";
import { ref } from "vue";
  export default {
    name: 'GlobalConfirmationDialogComponent',
    components: {
      WorkButton
    },
    props: {
      component: { type: Object, required: true },
      confirmation: { type: Object, required: true },
    },
    setup() {
      const confirmationDialog = ref(null);

      function open() {
        return confirmationDialog.value?.open();
      }

      return {
        confirmationDialog,
        open,
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>